<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入事件名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入事件名称"
          />
        </a-form-item>
        <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['imageUrl']"
          />
        </a-form-item>
        <a-form-item
          label="是否发奖"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isAward"
            @change="changeHandler"
          />
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'prizeSource',
              { rules: [{ required: true, message: '请选择奖品来源' }] },
            ]"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandle"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            id="prizeId"
            v-decorator="[
              'prizeId',
              { rules: [{ required: true, message: '请选择奖品' }] },
            ]"
            placeholder="请选择奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="是否统计关注人数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="countNumFlag"
            @change="changeHandler2"
          />
        </a-form-item>
        <a-form-item
          v-if="countNumFlag && !disabledFlag"
          label="初始值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="followNumCount"
            v-decorator="['followNumCount']"
            placeholder="请输入关注人数基础值"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
// import JImageUpload from '../../../../components/jeecg/JImageUpload';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'AttentionEventModal',
  components: {
    JDate,
    JMultiSelectTag,
    // JImageUpload,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      disabledFlag: false, //不可编辑标识
      isAward: false, //是否发奖开关，默认关闭状态
      countNumFlag: false, //统计关注人数，默认关闭状态
      prizesList: [], //奖品列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: '1',
        },
        {
          name: '积分库',
          value: '2',
        },
      ], //奖品来源
      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/attention/cfh/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/attention/cfh/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (this.model.isAward === '1') {
        this.isAward = true;
      } else {
        this.isAward = false;
      }
      if (this.model.countNumFlag === '1') {
        this.countNumFlag = true;
      } else {
        this.countNumFlag = false;
      }
      if (this.model.id) {
        this.disabledFlag = true;
      } else {
        this.disabledFlag = false;
      }
      this.fileList = record.imageUrl;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          imageUrl: record.imageUrl
            ? process.env.VUE_APP_FILE_PATH + record.imageUrl
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            // 'imageUrl',
            'isAward',
            'prizeSource',
            'prizeId',
            'countNumFlag',
            'followNumCount'
          )
        );
      });

      this.prizeSourceHandle(this.model.prizeSource);
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          formData.isAward = that.isAward === true ? '1' : '0';
          formData.countNumFlag = that.countNumFlag === true ? '1' : '0';
          formData.imageUrl = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'imageUrl',
          'isAward',
          'prizeSource',
          'prizeId',
          'countNumFlag',
          'followNumCount'
        )
      );
    },

    prizeSourceHandle(e) {
      this.form.setFieldsValue({
        //《=关键 清空tag选项
        prizeId: [],
      });
      this.prizesList = [];
      if (e === '1' || e === '2') {
        this.getPrizesList(e);
      }
    },

    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
        }
      });
    },

    changeHandler(e) {
      this.isAward = e;
    },
    changeHandler2(e) {
      this.countNumFlag = e;
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        imageUrl: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
